import defineService from "./defineService";


export const getUploads = defineService(
  'get', 'spool/uploads/'
);

export const getUpload = defineService(
  'get', 'spool/uploads/:id/'
);

export const patchUpload = defineService(
  'patch', 'spool/uploads/:id/'
)

export const postUploadNote = defineService(
  'post', 'spool/uploads/:id/notes/'
);


export const getTags = defineService(
  'get', 'spool/tags/'
);



// WEBPACK FOOTER //
// ./src/services/uploads.js